if($('header#header').length){
    $('.navigation-buttons a[data-target="cart"]').clone().appendTo('.responsive-tools')
    $('.header-top').append($('.top-navigation-bar .responsive-tools'))
    $('#customerLogin input[name="email"]').attr('placeholder', '').before('<label for="email">Uživatelské jméno nebo e-mail<span>*</span></label>')
	$('#customerLogin input[name="password"]').attr('placeholder', '').before('<label for="password">Heslo<span>*</span></label>')
    $('<span class="close"></span>').appendTo('.login-widget .popup-widget-inner');    
    $('nav#navigation .menu-image img').each(function(){
        if($(this).attr('data-src')){
            $(this).attr('data-src', $(this).attr('data-src').replace('thumb', 'orig'))
            $(this).attr('src', $(this).attr('data-src'))
        }
       
    })
    $(document).on("click", ".login-widget .popup-widget-inner .close", function(){
        $('body').removeClass('user-action-visible login-window-visible')
    }) 
    $(document).on('click', function (event) {
        var clickedElement = $(event.target);
        
        if (!(clickedElement.closest('.login-widget').length || clickedElement.is('a[data-target="login"]'))) {
            $('body').removeClass('login-window-visible user-action-visible');
        }
    });  
    $('html').on('mouseover', '.menu-level-1 li', function () {
        $('body').addClass('menuHovered')
    });

    $('html').on('mouseleave', '.menu-level-1 li', function () {
        $('body').removeClass('menuHovered')
    });
    $('.password-helper').after('<div class="newRegister"><p><span>nebo</span></p></div>')
    $('.newRegister').append($('.password-helper a[data-testid="signup"]'))

    
    if(!$('footer#footer').length){
        $(document).ready(function () {
            if(sessionStorage.loadedFooter) {
              $('.overall-wrapper').append('<footer id="footer">'+sessionStorage.loadedFooter+'</footer>')
              customHeader()
            } else {
              $.ajax({
                type: "GET",
                dataType: "html",
                timeout: 1e4,
                cache: !0,
                url: "/",
                success: function(e) {
                    var a = shoptet.common.createDocumentFromString(e),
                    t = $(a).find("footer#footer").html();
                    null !== t && ($('.overall-wrapper').append('<footer id="footer">'+t+'</footer>'))
                    sessionStorage.loadedFooter = $("footer#footer").html();
                    customHeader()
                    }
                });
            }
        })
    }
    else{
        customHeader()
    }
    function customHeader(){
        var dataMenuMap = {};
        $('.customMenuBanner > li').each(function() {
            var dataMenuValue = $(this).data('menu');
            dataMenuMap[dataMenuValue] = $(this).html();
        });
        $('.menu-level-1 > li > a').each(function() {
            var hrefValue = $(this).attr('href');
            if (dataMenuMap.hasOwnProperty(hrefValue)) {
                $(this).closest('li').find('.menu-level-2').addClass('superSubmenu').html(dataMenuMap[hrefValue]);
            }
        });
        $('#customerLogin').prepend($('footer#footer .registerPlus').clone())
    }

}




